import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { SegmentOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchSegments(): Promise<SegmentOut[]> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = await instance.get(API_ROUTES.LIST_DYNAMIC_BONUS_SEGMENTS);
  return bonusAdminBody<SegmentOut[]>(response) ?? [];
}

export const LIST_SEGMENTS_QUERY_KEY = ["LIST_DYNAMIC_BONUS_SEGMENTS"] as const;

export const useListSegments = () => {
  return useQuery<SegmentOut[]>({
    queryKey: LIST_SEGMENTS_QUERY_KEY,
    queryFn: fetchSegments,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
